import React, { useEffect } from "react";
import styled from "styled-components";
import AOS from "aos";
import "aos/dist/aos.css";

function Feedback() {
  useEffect(() => {
    AOS.init({
      duration: 1200,
    });
  }, []);

  return (
    <Container>
      <Wrap>
        <Left data-aos="fade-left">
          <h1 className='shine' data-aos="fade-up">WE’D LOVE TO HEAR FROM YOU!</h1>

          <p>
          At IBEX FILMZ, we bring your ideas to life through motion. Whether you’re envisioning a compelling brand story, a breathtaking photoshoot, or cinematic visuals that captivate your audience, we’re here to make it happen. <br></br>
          Have a project in mind? <br></br> Need expert advice or creative consultation? <br></br> Exploring potential collaborations? <br></br> Our team of passionate storytellers is ready to collaborate and craft something extraordinary with you. Let’s transform your vision into stunning reality.
          </p>
          <button className="button">
            <h6 className="text">contact us</h6>
            <span className="icon">
              <svg
                viewBox="0 0 512 512"
                xmlns="http://www.w3.org/2000/svg"
                data-icon="paper-plane"
                width="20px"
                aria-hidden="true"
              >
                <path
                  d="M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"
                  fill="currentColor"
                ></path>
              </svg>
            </span>
          </button>
        </Left>

        <Right data-aos="fade-right">
          <Loader className="loader">
            <div className="box">
              <div className="logo">
                <img src="./logo.jpg" /> 
              </div>
            </div>
            <div className="box"></div>
            <div className="box"></div>
            <div className="box"></div>
            <div className="box"></div>
          </Loader>
        </Right>
      </Wrap>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  min-height: 42vh;
  background: var(--primary-color);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Wrap = styled.div`
  width: 95%;
  height: 100%;
  display: flex;
  padding-left: 20px;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(10px);
  background: var(--secondary-background-color);
  background-size: 30px 30px;
  background-position: -5px -5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  padding: 10px;

  @media only screen and (max-width: 1200px) {
    flex-direction: column;
  }
`;

const Left = styled.div`
  width: 70%;
  padding-right: 220px;
  padding: 20px;

  @media only screen and (max-width: 1200px) {
    width: 100%;
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  h1 {
    text-align: left;
    color: var(--text-color);
    font-size: 32px;
    text-transform: uppercase;
    margin: 20px 0;

    @media only screen and (max-width: 1200px) {
      text-align: center;
      font-size: 35px;
    }
  }

  p {
    line-height: 2rem;
    padding: 10px 0;
    margin-bottom: 10px;
    color: #fff;

    @media only screen and (max-width: 1200px) {
      text-align: center;
      font-size: 14px;
    }
  }
`;

const Right = styled.div`
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  @media only screen and (max-width: 1200px) {
    padding: 50px 0;
    width: 100%;
  }
`;

const Loader = styled.div`
  --size: 200px;
  --size_mobile: 200px;
  --duration: 2s;
  --logo-color: grey;
  --background: linear-gradient(
    0deg,
    rgba(50, 50, 50, 0.2) 0%,
    rgba(100, 100, 100, 0.2) 100%
  );
  height: var(--size);
  aspect-ratio: 1;
  position: relative;

  

  .box {
    position: absolute;
    background: rgba(100, 100, 100, 0.15);
    background: var(--background);
    border-radius: 50%;
    border-top: 1px solid rgba(100, 100, 100, 1);
    box-shadow: rgba(0, 0, 0, 0.3) 0px 10px 10px -0px;
    backdrop-filter: blur(5px);
    animation: ripple var(--duration) infinite ease-in-out;
  }

  .box:nth-child(1) {
    inset: 40%;
    z-index: 99;
  }

  .box:nth-child(2) {
    inset: 30%;
    z-index: 98;
    border-color: rgba(100, 100, 100, 0.8);
    animation-delay: 0.2s;
  }

  .box:nth-child(3) {
    inset: 20%;
    z-index: 97;
    border-color: rgba(100, 100, 100, 0.6);
    animation-delay: 0.4s;
  }

  .box:nth-child(4) {
    inset: 10%;
    z-index: 96;
    border-color: rgba(100, 100, 100, 0.4);
    animation-delay: 0.6s;
  }

  .box:nth-child(5) {
    inset: 0%;
    z-index: 95;
    border-color: rgba(100, 100, 100, 0.2);
    animation-delay: 0.8s;
  }

  .logo {
    position: absolute;
    inset: 0;
    display: grid;
    place-content: center;
    padding: 10%;

    img{
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }

  @keyframes ripple {
    0% {
      transform: scale(1);
      box-shadow: rgba(0, 0, 0, 0.3) 0px 10px 10px -0px;
    }
    50% {
      transform: scale(1.3);
      box-shadow: rgba(0, 0, 0, 0.3) 0px 30px 20px -0px;
    }
    100% {
      transform: scale(1);
      box-shadow: rgba(0, 0, 0, 0.3) 0px 10px 10px -0px;
    }
  }
`;

export default Feedback;
